'use strict'

/**
 * @description DOMツリー読み込み完了後指定の関数を実行する
 */
export const mounted = func => {
  if (document.readyState !== 'loading') {
    func()
  } else {
    document.addEventListener('DOMContentLoaded', func)
  }
}

/**
 * @description HTMLエスケープを行う
 * @param {String} str
 */
export const escapeHtml = str => {
  if (!str) return ""
  str = str.replace(/</g, '&lt;')
  str = str.replace(/>/g, '&gt;')
  str = str.replace(/"/g, '&quot;')
  str = str.replace(/'/g, '&#39;')

  return str
}

export const escapeHtmlBr = str => {
  str = str.replace(/</g, '&lt;')
  str = str.replace(/>/g, '&gt;')
  str = str.replace(/"/g, '&quot;')
  str = str.replace(/'/g, '&#39;')
  str = str.replace(/&lt;br&gt;/g, '<br>')

  return str
}

/**
 * @description 指定要素に対してイベントを設定する
 * @param {Object} el [要素]
 * @param {String} ev [イベント名]
 * @param {Function} func [実行関数]
 */
export const addEvent = ({ el, ev, func }) => {
  if (el && el.length && el !== window) {
    for (const item of el) {
      item.addEventListener(ev, func, false)
    }
  } else {
    el.addEventListener(ev, func, false)
  }
}

export const extractionrAreaCodeData = (areaCode, data) => {
  const result = data.filter(value => {
    return value.area === areaCode
  })
  return result
}

/**
 * @description 指定要素に対してIntersectionObserverイベントを設定する
 * @param {Object} el [要素]
 * @param {Function} func [実行関数]
 */
export const addObserverEvent = ({ el, func }) => {
  const base = ({ observerEl, observerFunc }) => {
    const observer = new IntersectionObserver(e => {
      if (e[0].intersectionRatio) {
        const el = e[0].target

        observerFunc(el)
        observer.unobserve(observerEl)
      }
    })

    observer.observe(observerEl)
  }

  if (el && el.length) {
    for (const item of el) {
      base({
        observerEl: item,
        observerFunc: func
      })
    }
  } else {
    base({
      observerEl: el,
      observerFunc: func
    })
  }
}

/**
 * @description 開始要素から最も近い親要素を取得する
 * @param Object el [要素]
 * @param String className [class名]
 * @returns Object 指定class名のDom参照
 */
export const closest = (el, className) => {
  for (let item = el; item; item = item.parentElement) {
    if (item.classList.contains(className)) {
      return item
    }
  }
}

export const isApp = () => {
  const ua = window.navigator.userAgent.toLowerCase()
  let appType = 0

  switch (true) {
    case ua.indexOf('frnativeapp') != -1 && ua.indexOf('uq-ios-jp') != -1:
      appType = 1
      break
    case ua.indexOf('frnativeapp') != -1 && ua.indexOf('uq-android-jp') != -1:
      appType = 2
      break
    case ua.indexOf('circle-jp') != -1:
      appType = 3
      break
    case ua.indexOf('frnativeapp') != -1 && ua.indexOf('uq-ios-us') != -1:
      appType = 4
      break
    case ua.indexOf('frnativeapp') != -1 && ua.indexOf('uq-android-us') != -1:
      appType = 5
      break
    case ua.indexOf('frnativeapp') != -1:
      appType = 6
      break
  }

  return appType
}

export const isMobile = () => {
  const userAgent = window.navigator.userAgent.toLowerCase()

  if (
    userAgent.indexOf('iphone') != -1 ||
    userAgent.indexOf('ipod') != -1 ||
    (userAgent.indexOf('android') != -1 && userAgent.indexOf('mobile') != -1)
  ) {
    return true
  } else {
    return false
  }
}

export const bffRegion = () => {
  const bodyEl = document.body
  const bffRegion = bodyEl.dataset.bffRegion.includes('eu-')
    ? bodyEl.dataset.bffRegion.replace('eu-', '')
    : bodyEl.dataset.bffRegion

  return bffRegion
}

export const bffVersion = () => {
  const bodyEl = document.body
  const bffVersion = bodyEl.dataset.bffVersion

  return bffVersion
}

/**
 * @description 文字列の日付をDateインスタンスに変換する
 * @param dateTxt YYYYMMDDhhmm形式のテキスト
 * @returns Dateインスタンス
 */
export const TexttoDate = dateTxt => {
  const year = dateTxt.substr(0, 4)
  const month = dateTxt.substr(4, 2)
  const day = dateTxt.substr(6, 2)
  const time = dateTxt.substr(8, 2)
  const minutes = dateTxt.substr(10, 2)

  return new Date(year, month - 1, day, time, minutes, '00')
}

/**
 * @description 特定のパラメータを取得
 * @param name 取得したいパラメータのkey
 * @param url 取得したい元のurl
 * @returns paramのバリュー
 */
export const getParam = (name, url) => {
  if (!url) url = window.location.href
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  const results = regex.exec(url)
  // console.log(url)
  // console.log(name)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}
